import $http from '@/plugins/axios'
import $utils from '@/utils/utils'
import { BaseServiceLevel2 } from '@/services/base.service'

const QcCampaignService = {
    DataInputService: BaseServiceLevel2('qc/campaigns', 'data-input'),
    ASRCriteriaService: BaseServiceLevel2('qc/campaigns', 'asr-criteria'),
    CriteriaService: BaseServiceLevel2('qc/campaigns', 'criterias'),
    UserPermissionService: BaseServiceLevel2('qc/campaigns', 'users-assign'),
    CallListService: BaseServiceLevel2('qc/campaigns', 'call-list'),
    ReportMetricService: BaseServiceLevel2('qc/campaigns', 'report-metrics'),
    getQCBatch (qcCampaignId, page_size, page, ordering, search) {
        let params = { page_size, page, ordering, search }
        let endPoint = $utils.buildQuery(`/qc/campaigns/${qcCampaignId}/call-list`, params)
        return $http.get(endPoint)
    },
    updateCallStatus (qcCampaignId, batchId, callId, model) {
        return $http.patch(`/qc/campaigns/${qcCampaignId}/call-list/${batchId}/calls/${callId}/`, model)
    },
    createCallRecord (qcCampaignId, batchId, callId, model) {
        return $http.post(`/qc/campaigns/${qcCampaignId}/call-list/${batchId}/calls/${callId}/records/`, model)
    },
    updateCallRecord (qcCampaignId, batchId, callId, recordId, model) {
        return $http.patch(`/qc/campaigns/${qcCampaignId}/call-list/${batchId}/calls/${callId}/records/${recordId}/`, model)
    },
    checkStatusCallQC (qcCampaignId, callQCId) {
        return $http.post(`/qc/campaigns/${qcCampaignId}/calls/${callQCId}/check-status-call/`)
    },
    getCallRecord (qcCampaignId, batchId, callId) {
        return $http.get(`/qc/campaigns/${qcCampaignId}/call-list/${batchId}/calls/${callId}/records/`)
    },
    getCallAudio (callQCId) {
        let headers = {'use-default-custom': true}
        return $http.get(`/qc/calls/${callQCId}/get-audio-call/`, {
            responseType: 'blob',
            headers: headers
        })
    },
    getCriteria (qcCampaignId) {
        let endPoint = $utils.buildQuery(`/qc/campaigns/${qcCampaignId}/criterias`)
        return $http.get(endPoint)
    },
    getQCStatusStatistics (qcCampaignId, batchId) {
        let endPoint = $utils.buildQuery(`/qc/campaigns/${qcCampaignId}/call-list/${batchId}/qc-status-statistics`)
        return $http.get(endPoint)
    },
    getQCCall (qcCampaignId, batchId, callId) {
        let endPoint = $utils.buildQuery(`/qc/campaigns/${qcCampaignId}/call-list/${batchId}/calls/${callId}/`)
        return $http.get(endPoint)
    },
    getQCCallHistory (callId) {
        let endPoint = $utils.buildQuery(`/qc/calls/${callId}/history/`)
        return $http.get(endPoint)
    },
    getCallsForBatch (qcCampaignId, batchId, params) {
        let endPoint = $utils.buildQuery(`/qc/campaigns/${qcCampaignId}/call-list/${batchId}/call-data`, params)
        return $http.get(endPoint)
    },
    importQCCampaignPermission (QCCampaignId, formData) {
        let header = {
            'Content-Type': 'multipart/form-data'
        }
        return $http.post(`qc/campaigns/${QCCampaignId}/import-campaign-permission/`, formData, { headers: header })
    },
    getCampaignPermissionTemplate (QCCampaignId) {
        return $http.get(`qc/campaigns/${QCCampaignId}/template-campaign-permission/`, { responseType: 'blob' })
    },
    getQCCampaignRoles () {
        return $http.get(`qc/roles/`)
    },
    getQCCampaigns (page_size, page, ordering, search, permission = '', call_campaign_id = '') {
        let params = { page_size, page, ordering, search, permission, call_campaign_id }
        let endPoint = $utils.buildQuery('/qc/campaigns/', params)
        return $http.get(endPoint)
    },
    getQCCampaign (id) {
        return $http.get('qc/campaigns/' + id + '/')
    },
    createQCCampaign (model) {
        return $http.post('qc/campaigns/', model)
    },
    deleteQCCampaign (campaign) {
        return $http.delete('qc/campaigns/' + campaign.id + '/')
    },
    updateQCCampaign (campaign, model) {
        return $http.put('qc/campaigns/' + campaign.id + '/', model)
    },
    exportReportBatch (campaign, callList) {
        return $http.get(`qc/campaigns/${campaign.id}/call-list/${callList.id}/export-report-batch/`, { responseType: 'blob' })
    },
    getOverviewQCCampaignData (campaignId) {
        return $http.get(`qc/campaigns/${campaignId}/overview/`)
    },
    getPendingTasksChartData (campaignId, callListId) {
        return $http.get(`qc/campaigns/${campaignId}/call-list/${callListId}/pending-tasks-chart/`)
    },
    getResultQCChartData (campaignId, filter) {
        return $http.get(`qc/campaigns/${campaignId}/result-chart/`, { params: filter })
    },
    getAllBatches (campaignId) {
        return $http.get(`qc/campaigns/${campaignId}/all-call-list/`)
    },
    getCallQcAvailable (campaignId, model) {
        return $http.post(`qc/campaigns/${campaignId}/call-qc-available/`, model)
    },
    addCallToBatch (campaignId, callListId, model) {
        return $http.post(`qc/campaigns/${campaignId}/call-list/${callListId}/add-call-to-batch/`, model)
    },
    getNextQcCall (campaignId, callListId, model) {
        return $http.post(`qc/campaigns/${campaignId}/call-list/${callListId}/next-call/`, model)
    },
    swapCriteria (campaignId, model) {
        return $http.post(`qc/campaigns/${campaignId}/swap-criteria/`, model)
    },
    swapASRCriteria (campaignId, model) {
        return $http.post(`qc/campaigns/${campaignId}/swap-asr-criteria/`, model)
    },
    swapReportMetric (campaignId, model) {
        return $http.post(`qc/campaigns/${campaignId}/swap-metric/`, model)
    },
    getOrCreateSentenceQc (qcCallId, model) {
        return $http.post(`/qc/calls/${qcCallId}/sentences/`, model)
    },
    getRecordSentenceQc (qcCallId, sentenceId) {
        return $http.get(`/qc/calls/${qcCallId}/sentences/${sentenceId}/record-sentences/`)
    },
    createOrUpdateRecordSentenceQc (qcCallId, sentenceId, model) {
        return $http.post(`/qc/calls/${qcCallId}/sentences/${sentenceId}/record-sentences/`, model)
    },
    getDataInputSuggestion(campaignId) {
        return $http.get(`qc/campaigns/${campaignId}/data-suggest/`)
    },
    exportReportCampaign (campaignId, filter) {
        return $http.get(`qc/campaigns/${campaignId}/export-report/`, { params: filter })
    },
    getAsrAudio (path) {
        return $http.get(`qc/get-asr-audio/${path}`, {
            responseType: 'blob',
        })
    },
}
export default QcCampaignService
